import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import ActivityBugSolver from './activity-bug-solver';
import { useLocation } from 'react-router-dom';

const Page = () => {
  const activityId = useLocation()?.state?.activityId;
  
  return (
    <Panel
      header={
        <PageHeader title="Activity Bug Solver">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >Master Data</Breadcrumb.Item>
            <Breadcrumb.Item active>Activity Bug Solver</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <ActivityBugSolver activityId={activityId}/>
    </Panel>
  );
};

export default Page;
